export enum LoginMethod {
  BANK_ID = "nbid",
  BUYPASS = "buypass",
}

export enum LoginRole {
  ADMIN = "ADMIN",
  VIRKSOMHET = "VIRKSOMHET",
}

export const AVAILABLE_LANGUAGES = ["nb", "nn", "en"] as const;
